import { render, staticRenderFns } from "./WeeklySales.vue?vue&type=template&id=20150f59"
import script from "./WeeklySales.vue?vue&type=script&lang=js"
export * from "./WeeklySales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports